import { defineComponent as _defineComponent } from 'vue'
import { toRefs, ref, watch, Ref } from 'vue';
import CoverArrayInput from '@/components/collections/CoverArrayInput.vue';
import type { ContentReference } from '@ilteducation/content-collections-types';
import { MaterialV1 } from '@ilteducation/content-registry-types';

type Emits = {
  (e: 'update:modelValue', contentLinks: MaterialV1['contentLinks']): void;
};
type Props = {
  contentLinks: MaterialV1['contentLinks'];
  realm: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentLinks',
  props: {
    contentLinks: null,
    realm: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', contentLinks: MaterialV1['contentLinks']): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  contentLinks: MaterialV1['contentLinks'];
  realm: string;
}




const { contentLinks } = toRefs(props);

const model = ref<ContentReference[]>(
  (contentLinks.value ?? []).map((contentLink) => ({ id: contentLink.id, type: contentLink.contentType })),
);

watch(
  () => props.contentLinks,
  (newVal) => {
    model.value = (newVal ?? []).map((contentLink) => ({ id: contentLink.id, type: contentLink.contentType }));
  },
);
const update = (contentReferences: ContentReference[]) => {
  const newLinks = contentReferences.map((contentReference) => ({
    id: contentReference.id,
    contentType: contentReference.type,
  }));
  emit('update:modelValue', newLinks);
};

return { __sfc: true,emit, props, contentLinks, model, update, CoverArrayInput }
}

})